<template>
    <ies-form-field :field="field">
        <input :name="this.field.fieldName"
               type="number"
               v-model="input"
               :required="this.field.required"
               :disabled="this.field.disabled"
               v-on:change="updateField()">
    </ies-form-field>
</template>

<script>
export default {
    name: 'ies-integer',
    props: ['field'],
    components: {
        'ies-form-field': require('./FormField.vue').default,
    },
    data () {
        return {
            input: this.field.value || this.field.oldValue,
        }
    },
    methods: {
        updateField: function(){
            this.field.value = this.input
        }
    },
}
</script>


